<script>
import Layout from '../../layouts/main'
import PageHeader from "@/components/page-header";
import { GridComponent, ColumnsDirective, ColumnDirective,
  Page, Toolbar, Sort, Filter, Resize, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import api from "@/axios";
import moment from "moment";
import Loader from "@/router/views_mobagile/components/loader.vue";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  components: {
    Loader, Layout, PageHeader,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
  },

  data() {
    return {
      flagCompras: false,
      title: "Cotação Dedicada",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Cotação Dedicada",
          active: true
        }
      ],
      dataList: null,
      loading: true,
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
      submittedPeriodo: false,
      erroPeriodo: '',
      filterSettings: { type: 'Excel' },
      toolbar: [
        { text: 'Nova Cotação', prefixIcon: 'e-plus', id: 'novaCota', align: 'Left' },
      ],
      userPct: null,
      empresaPct: null,
      totaisPct: null,

    };
  },

  mounted() {
    console.log('mounted cotar-frete-ded-list')
    this.atualizaDataList()
  },

  provide: {
    grid: [Page, Toolbar, Sort, Filter, Resize, PdfExport, ExcelExport]
  },

  methods: {


    upgradePlano(){
      console.log('upgradePlano')
      this.$router.push('/usuario/perfil/' + this.userLogged.id)
    },

    tbClickHandler: function(args) {
      console.log('tbClickHandler')
      console.log(args.item.id)
      this.loading = true

      if (args.item.id === 'novaCota') {
        console.log('novaCota')
        this.$router.push(`/cotafrtded/editarded/0`)
      }

      else if (args.item.id === 'exportExcel') {
        const fileProps = {
          fileName: 'cotacoes.xlsx'
        }
        this.$refs.dataGrid.excelExport(fileProps)
      }

      else if (args.item.text === 'exportCsv') {
        const fileProps = {
          fileName: 'cotacoes.csv'
        }
        this.$refs.dataGrid.csvExport(fileProps)
      }

      this.loading = false
    },

    recordDoubleClick(evt){
      console.log('recordDoubleClick')
      console.log(evt.rowData.id);
      const routeData = this.$router.resolve(`/cotafrtded/editarded/${evt.rowData.id}`)
      window.open(routeData.href, '_blank')
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      let difDias = moment(this.dtFimFiltro).diff(moment(this.dtIniFiltro), 'days')
      console.log(difDias)
      if (difDias < 31) {
        localStorage.setItem('filtros', JSON.stringify({
          'di': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
          'df': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
        }))
        this.showModalPeriodo = false
        this.atualizaDataList()
      } else {
        this.erroPeriodo = 'Diferença entre data inicial e final deve ser menor que 31 dias, caso necessário um período maior favor entrar em contato com suporte.'
      }
    },

    atualizaDataList(){
      console.log('atualizaDataList_CotaDed')
      this.loading = true

      api.get(`${getBaseUrl()}api/userpct`, {
        params: {
          'tabela': 'cotacao'
        }
      }).then(response => {
        console.log('response.userpct')
        console.log(response)
        this.userPct = response.data[0]
        this.empresaPct = response.data[1]
        this.totaisPct = response.data[2]
      })

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      if (!filtros) {
        let perIniPadrao = moment(new Date()).startOf('month').format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date()).endOf('month').format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      const paramsReq = {
        'di': this.dtIniFiltro,
        'df': this.dtFimFiltro,
      }
      api.get(`${getBaseUrl()}api/cotafrtdeds`, {
        params: paramsReq,
      }).then(response => {
        console.log('response.data_0')
        console.log(response)
        this.dataList = response.data[0]
        this.dataList.forEach((value) => {
          if (value.created_at){
            value.created_at = moment(value.created_at).format('DD/MM/YYYY')
          }
        })
        this.loading = false
        const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
        this.title = `(${this.dataList.length}) Cotação Dedicada: ${dtIniFormated} - ${dtFimFormated}`
      })
    },

    rowDataBound: function (args) {
      const valStatus = args.data["status"]
      args.row.classList.add("sts-"+ valStatus.toLowerCase())
    },

    formatDecimal(value) {
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <b-alert show dismissible
             v-if="userPct && userPct.id > 0 && dataList"
             :variant="userPct.limite - userPct.consumo <= 10 ? 'danger' : userPct.limite - userPct.consumo <= 50 ? 'warning' : 'info'">
      <a class="dropdown-item "
         @click="upgradePlano"
         href="javascript: void(0);">
        <i class="mdi mdi-alert me-2"></i>Plano atual consumindo {{ userPct.consumo }} unidade(s) das {{ userPct.limite }} contratada(s), <span class="text-warning">clique aqui e faça upgrade agora mesmo.<i class="mdi mdi-rocket-launch ms-2"></i> </span>
      </a>
    </b-alert>

    <Loader v-if="loading" style="min-height: 300px;">
    </Loader>
    <div v-if="!loading">
      <ejs-grid :dataSource="dataList"
                ref="dataGrid"
                :allowFiltering="true"
                :allowPdfExport="true"
                :allowExcelExport="true"
                :allowPaging="true"
                :filterSettings="filterSettings"
                :toolbar="toolbar"
                :recordDoubleClick="recordDoubleClick"
                :toolbarClick="tbClickHandler"
                :rowDataBound="rowDataBound"
                :pageSettings="{ pageSizes: ['30', '100', '200', '500', 'All'], pageSize: 30 }"
                :selectionSettings="{ mode: 'Row', type: 'Multiple' }"
                :scrollSettings="{enableColumnScrolling: true, enableRowScrolling: true}">
        <e-columns>
          <e-column field="id" headerText="ID" textAlign="Left"></e-column>
          <e-column field="status" headerText="Status" textAlign="Center"></e-column>
          <e-column field="cidori" headerText="Cidade Origem" textAlign="Left"></e-column>
          <e-column field="ufori" headerText="UF Origem" textAlign="Left"></e-column>
          <e-column field="cepori" headerText="CEP Origem" textAlign="Right"></e-column>
          <e-column field="ciddest" headerText="Cidade Destino" textAlign="Left" ></e-column>
          <e-column field="ufdest" headerText="UF Destino" textAlign="Left"></e-column>
          <e-column field="cepdest" headerText="CEP Destino" textAlign="Right"></e-column>
          <e-column field="dist" headerText="Distância" textAlign="Right"></e-column>
          <e-column field="tempo" headerText="Tempo" textAlign="Right"></e-column>
          <e-column field="created_at" headerText="Data" textAlign="Right" format="dd/MM/yyyy"></e-column>
          <e-column field="valor" headerText="Valor" textAlign="Right"></e-column>
        </e-columns>

        <template v-slot:templtvalor="{data}">
          <div> {{formatDecimal(data.valor)}} </div>
        </template>
        <template v-slot:templtdist="{data}">
          <div> {{formatDecimal(data.dist)}} </div>
        </template>

      </ejs-grid>
    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="perexib">Selecionar Data Inicial e Final</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>
      </div>
      <b-alert v-if="this.erroPeriodo !== ''"  show dismissible variant="danger" >
        <i class="mdi mdi-alert me-2"></i> {{ erroPeriodo }}
      </b-alert>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


  </Layout>
</template>

<style>

.sts-ab {
  background-color: rgba(78,59,0,0.5);
}
.sts-co {
  background-color: rgba(0,58,78,0.5);
}
.sts-ca {
  background-color: rgba(146,20,0,0.5);
}

</style>